// Applying and: true will put an 'and' line before the name in the list
const credits = [
  {
    name: 'Tom Abba',
    role: '',
    link: 'https://tomabba.com/',
    editions: [1, 2]
  },
  {
    name: 'Duncan Speakman',
    role: '',
    link: 'https://duncanspeakman.net/',
    editions: [1, 2]
  },
  {
    name: 'Emilie Grenier',
    role: '',
    link: '',
    editions: [1]
  },
  {
    name: 'Amy Spencer',
    role: '',
    link: '',
    editions: [1]
  },
  {
    name: 'Neil Gaiman',
    role: '',
    link: 'https://www.neilgaiman.com/',
    editions: [1],
    and: true
  },
  {
    name: 'Nick Harkaway',
    role: '',
    link: 'http://www.nickharkaway.com/',
    editions: [1]
  },
  {
    name: 'Tom Melamed',
    role: 'technical infrastructure',
    link: '',
    editions: [1]
  },
  {
    name: 'Ruth Essex',
    role: 'location management',
    link: '',
    editions: [1]
  },
  {
    name: 'Eugene Byrne',
    role: 'historical notes',
    link: '',
    editions: [1]
  },
  {
    name: 'Sam Davey',
    role: '',
    link: '',
    editions: [2]
  },
  {
    name: 'Arjan Scherpenisse',
    role: '',
    link: '',
    editions: [2]
  },
  {
    name: 'Tom Burton',
    role: '',
    link: '',
    editions: [2]
  },
  {
    name: 'Josh Connor',
    role: 'technical production',
    link: '',
    editions: [2]
  }
]
export default credits
